const kinesisConfig = {
  AWSKinesisFirehose: {
    region: process.env.REGION || '|',
  },
};

export default kinesisConfig;
